import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';

let Ionicons: any, FontAwesome: any, MaterialIcons: any, Entypo: any, AntDesign: any;
try {
    Ionicons = require('react-native-vector-icons/Ionicons').default;
    FontAwesome = require('react-native-vector-icons/FontAwesome').default;
    MaterialIcons = require('react-native-vector-icons/MaterialIcons').default;
    Entypo = require('react-native-vector-icons/Entypo').default;
    AntDesign = require('react-native-vector-icons/AntDesign').default;
} catch {
    // 兼容未安装时降级
    Ionicons = FontAwesome = MaterialIcons = Entypo = AntDesign = null;
}

// 类型定义
type IoniconsName = string;
type FontAwesomeName = string;
type MaterialIconsName = string;
type EntypoName = string;
type AntDesignName = string;

type IconFamilyMap = {
    Ionicons: IoniconsName;
    FontAwesome: FontAwesomeName;
    MaterialIcons: MaterialIconsName;
    Entypo: EntypoName;
    AntDesign: AntDesignName;
};
type IconFamily = keyof IconFamilyMap;

export interface DbIconProps<F extends IconFamily = 'Ionicons'> {
    name: IconFamilyMap[F];
    family?: F;
    size?: number;
    color?: string;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
}

const DbIcon = <F extends IconFamily = 'Ionicons'>({
    name,
    family = 'Ionicons' as F,
    size = 24,
    color = '#000',
    style,
    onPress,
}: DbIconProps<F>) => {
    const renderIcon = () => {
        switch (family) {
            case 'Ionicons':
                return Ionicons ? <Ionicons name={name as IoniconsName} size={size} color={color} /> : null;
            case 'FontAwesome':
                return FontAwesome ? <FontAwesome name={name as FontAwesomeName} size={size} color={color} /> : null;
            case 'MaterialIcons':
                return MaterialIcons ? <MaterialIcons name={name as MaterialIconsName} size={size} color={color} /> : null;
            case 'Entypo':
                return Entypo ? <Entypo name={name as EntypoName} size={size} color={color} /> : null;
            case 'AntDesign':
                return AntDesign ? <AntDesign name={name as AntDesignName} size={size} color={color} /> : null;
            default:
                return null;
        }
    };

    return (
        <View style={style} onTouchEnd={onPress}>
            {renderIcon()}
        </View>
    );
};

export default DbIcon;
